<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li v-if="isLogged" class='breadcrumb-item'>
          <a href='/archive-orders'>{{ translations('navbar.sale_management') }}</a>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('navbar.shipping_instruction') }}</li>
      </ol>
    </nav>
    <v-app class='container-fluid main-container'>
      {{ isLogged ? translations('shipping_instruction.normal_user') : (isWarehouseUser ? translations('shipping_instruction.warehouse_user') : '') }}
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap mt-1">
          <div class="form-group mr-1">
            <input type="text" class="form-control" v-model='searchWord' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <div class="dropdown">
              <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ selectWarehouseName }}
              </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' @click='selectWarehouseId=0'>{{ translations('shipping_instruction.warehouse_selection') }}</a>
                <a class='dropdown-item' v-for='(item, i) in warehouses' :key='i' @click='selectWarehouseId=item.id'>{{ item.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group d-flex align-items-center flex-wrap">
            <span class="text-nowrap mr-1">{{ translations('sale.ship_date') }}</span>
<!--            <input v-model="shippingDate" type="date" class="form-control" @blur='triggerDateFilter()' @focus="tempDateField = shippingDate">-->
            <input v-model="shippingDate" type="date" class="form-control">
          </div>
          <div class="form-group d-flex align-items-center flex-wrap ml-2">
            <span class="text-nowrap mr-1">{{ translations('shipping_instruction.number_of_shipments') }}：{{ calcTotal() }} {{ translations('shipping_instruction.subject') }}</span>
          </div>
          <div class="form-group mr-2">
            <button class="btn btn-outline-secondary ml-2" type="button" @click="showTempShipping">
              {{ translations('shipping_instruction.show_direct_delivery') }}
            </button>
            <input
              v-model="isShowAllShipping"
              id="all"
              type="checkbox"
              name="all"
              class="pointer-clickable input-select-type ml-2 mr-1">
            <label for="all">{{ translations('shipping_instruction.all') }}</label>
          </div>

          <div class="form-group d-flex align-items-center flex-wrap ml-2">
            <span class="text-nowrap mr-1">{{ translations('shipping_instruction.number_of_order_numbers') }}：{{ calcTotalTag() }} {{ translations('shipping_instruction.subject') }}</span>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-group mt-1">
          <div class="form-group">
            <div v-if="confirmDetails.length && !isAllConfirm" class="mr-2 text-warning">{{ translations('shipping_instruction.hidden') }}</div>

            <!-- YAMA@UNIQ ADD 2021/12 -->
            <button class="btn btn-link btn-sm decoration-underline" type="button" @click="openDownloadFilesModal">{{ translations('shipping_instruction.download') }}</button>

            <div class="form-group mr-3">
              <button class="btn btn-outline-secondary" type="button" @click="openPrintModal(true)">
                {{ translations('shipping_instruction.print') }}
              </button>
            </div>
            <input @change="selectFile" ref="inputUploadFile" type="file" multiple style="width: 98px">
            <p v-if="masterFile.length === 0" class="mb-0" style="width: 150px">No file chosen</p>
            <button v-else class="btn btn-link btn-sm decoration-underline" type="button"
                    @click="openFilesModal (true)"
                    style="width: 150px;text-align: left"
                    >
              {{ translations('shipping_instruction.file_name_list') }}
            </button>
            <v-btn @click="uploadFile">{{ translations('shipping_instruction.upload') }}</v-btn>

            <button v-if="!isWarehouseUser" class="btn btn-link btn-sm decoration-underline" type="button" @click="isShowConfirmDialog=true" :disabled="!!searchWord">{{ translations('shipping_instruction.shipping_instruction_confirmed_registration') }}</button>
            <button class="btn btn-link btn-sm decoration-underline" type="button" @click="ShowRemarksDialog" :disabled="selectWarehouseId === 0 || (isWarehouseUser && !confirmData)">{{ translations('shipping_instruction.shipping_instruction_notes') }}</button>
            <button class="btn btn-link btn-sm decoration-underline" type="button" :disabled="!confirmData || !isEnableConfirm || !isAllConfirm" @click="exportCsv">{{ translations('shipping_instruction.shipping_instruction_csv') }}</button>

          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
            class="table table-striped"
            item-key="name"
            :headers="updatedHeaders"
            :items="shippings"
            :items-per-page="shippings.length"
            :options.sync="options"
            hide-default-footer
            hide-default-header
        >
          <template v-slot:header="{ props: { headers } }">
            <thead class="v-data-table-header">
              <tr>
                <th v-for="header in headers"
                    :key="header.value"
                    class="text-start"
                >
                  <span>{{ header.value === 'status' ? renderText(header) : header.value === 'show_hidden_soft_deleted_shipping_detail' ? '' : header.text }} </span>
                  <input
                    v-model="selectAll"
                    v-if="header.value === 'select_all' && !isWarehouseUser"
                    type="checkbox"
                    class="select-all"
                    :disabled="!shippings.length"
                  >
                  <input
                    v-model="selectAllTemp"
                    v-if="header.value === 'select_all_temp' && isWarehouseUser"
                    type="checkbox"
                    class="select-all"
                    :disabled="!shippings.length"
                  >
                  <input
                    v-model="selectAllMain"
                    v-if="header.value === 'select_all_main' && isWarehouseUser"
                    type="checkbox"
                    class="select-all"
                    :disabled="!shippings.length"
                  >
                  <input
                    v-model="selectAllDelete"
                    v-if="header.value === 'status'"
                    type="checkbox"
                    class="select-all"
                    :disabled="!shippings.length"
                  >
                  <span class="cover_input_red" v-if="header.value === 'show_hidden_soft_deleted_shipping_detail'">
                    <input
                      :disabled="renderText(header) === ''"
                      v-model="showHiddenDeletedShippingDetail"
                      type="checkbox"
                      class="select-all"
                      id="show_hidden_soft_deleted_shipping_detail"
                      style="width:0;height:0"
                    >
                    <label for="show_hidden_soft_deleted_shipping_detail">{{ header.text }}</label>
                  </span>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
            <template v-if="!isEmpty">
              <template v-for="(shipping, i) in items" >

                <tr v-if="!isLoggedSale(shipping.is_delete)" :key='i'>
                  <td>{{i + 1}}</td>
                  <td>
                    <v-tooltip v-if="!isWarehouseUser && confirmData" top>
                      <template v-slot:activator="{ on, attrs }">
                        <button v-bind="attrs" v-on="on" class="btn btn-sm text-center" :class="detailColorClass(shipping.id)" @click="detailAction(shipping.id)">{{ detailLabel(shipping.id) }}</button>
                      </template>
                      <span>{{ detailTooltipText(shipping.id) }}</span>
                    </v-tooltip>
                    <div v-else class="px-2 text-center" :class="detailColorClass(shipping.id)">{{ detailLabel(shipping.id) }}</div>
                  </td>
                  <td class="text-center">
                    <input :disabled="disableCheckBox(shipping)" v-model="shippingsSelectedDelete" type="checkbox" :value="shipping">
                  </td>
                  <td v-if="!isWarehouseUser" class="text-center">
                    <input v-model="shippingsSelected" type="checkbox" :value="shipping">
                  </td>
                  <td v-if="isWarehouseUser" class="text-center">
                    <input v-model="shippingsSelectedTemp" type="checkbox" :value="shipping" :disabled="disableInputPrintTemp(shipping)">
                  </td>
                  <td v-if="isWarehouseUser" class="text-center">
                    <input v-model="shippingsSelectedMain" type="checkbox" :value="shipping" :disabled="disableInputPrintMain(shipping)">
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">{{ shipping.shipping_schedule_at ? $invoiceTools.formatDate(shipping.shipping_schedule_at) : $invoiceTools.formatDate(shipping.shipping_at) }}</td>
                  <td v-if="!isWarehouseUser" :class="{'text-primary': isShippingTemp(shipping)}">{{ shipping.sales_number }}</td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">{{ shipping.ship_number ? shipping.ship_number : '-' }}</td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <span v-if="shipping.division_type !== 'B'">{{ shipping.client_name }}</span>
                    <span v-else>{{shipping.name_type_b_from }}</span>
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <ul>
                      <li v-for="(detail, i) in shipping.details" :key="i">{{detail.jan_code || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <ul>
                      <li v-for="(detail, i) in shipping.details" :key="i">{{detail.model || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <ul>
                      <li v-for="(detail, i) in shipping.details" :key="i">{{detail.quantity || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <ul>
                      <li v-for="(detail, i) in shipping.details" :key="i">{{detail.client_order_number || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <ul>
                      <li v-for="(detail, i) in shipping.details" :key="i">{{sliceNote(detail.internal_memo) || '&nbsp;'}}</li>
                    </ul>
                  </td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <span v-if="shipping.division_type !== 'B'">{{ shipping.destination_name }}</span>
                    <span v-else>{{shipping.name_type_b }}</span>
                  </td>
                  <td>{{ sliceNote(shipping.note) }}</td>
                  <td :class="{'text-primary': isShippingTemp(shipping)}">
                    <DivisionTypeText
                      v-if="shipping.estimate_id === null || parseInt(shipping.estimate_id) === 0"
                      :division_type="shipping.division_type"
                      :labelDefault="null"
                      :red="true"
                      :displayRemark="true"
                      :remark="shipping.details.length > 0 ? shipping.details[0].client_order_number : ''"
                    />
                    <p v-else>
                      {{shipping.name_order}}
                    </p>
                  </td>
                </tr>
              </template>

            </template>
            <template v-else>
              <tr class="odd">
                <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
              </tr>
            </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <div class="d-flex flex-wrap ml-13">
        <div class="form-group mr-5">
          <button class="btn btn-primary btn-sm text-white" type="button" @click="changeMultipleConfirm(false)" :disabled="disableButtonChangeMultipleConfirm()">{{translations('shipping_instruction.display')}}</button>
        </div>
        <div class="form-group">
          <button class="btn btn-warning btn-sm text-white" type="button" @click="changeMultipleConfirm(true)" :disabled="disableButtonChangeMultipleConfirm()">{{translations('shipping_instruction.hidden')}}</button>
        </div>
      </div>

      <v-dialog
          v-model="isShowRemarksDialog"
          persistent
          max-width="640px"
      >
        <v-card>
          <v-card-title class="justify-content-between">
            <table style="width: 100%">
              <tr>
                <th><span>{{ translations('shipping_instruction.shipping_instruction_notes') }}</span></th>
                <th>
                  <div class="d-flex flex-row justify-content-lg-end">
                    <button
                      :disabled="isWarehouseUser"
                      class="btn btn-outline-secondary me-2"
                      type="button"
                      @click="openSampleDocumentModal(true, false)">
                      {{ translations('common.addition') }}
                    </button>
                    <button
                      :disabled="isWarehouseUser"
                      class="btn btn-outline-secondary me-2"
                      type="button"
                      @click="openSampleDocumentModal(true, true)">
                      {{ translations('common.update') }}
                    </button>
                    <button
                      :disabled="isWarehouseUser"
                      class="btn btn-outline-secondary"
                      type="button"
                      @click="openSampleDeleteDocumentModal(true, true)">
                      {{ translations('common.delete') }}
                    </button>
                  </div>
                </th>
              </tr>
              <tr>
                <th colspan="2">
                  <div class="d-flex justify-content-lg-end">
                    <div class="form-group mt-2 mb-0">
                      <div class="dropdown">
                        <button
                          :disabled="isWarehouseUser"
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false">
                          {{ selectDocumentTitle }}
                        </button>
                        <div class="dropdown-menu menu-document">
                          <a class='dropdown-item' @click='clickDefaultDocument'>{{ translations('shipping_instruction.fixed_phrase_selection') }}</a>
                          <a class='dropdown-item' v-for='item in documents' :key='item.id' @click='clickDocument(item)'>{{ item.title }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </table>
          </v-card-title>
          <v-card-text>
            <v-textarea
                v-if="!isWarehouseUser"
                v-model="remarks"
                @blur="blurRemark"
                outlined
                hide-details
            ></v-textarea>
            <div v-else><pre class="body-2">{{ remarks }}</pre></div>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-btn
                text
                @click="closeRemarkDialog()"
            >
              {{ translations('common.close') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                v-if="!isWarehouseUser"
                color="primary"
                @click="saveRemarks"
            >
              {{ translations('common.keep') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <vue-element-loading :active="isLoadingModal"/>
      </v-dialog>

      <v-dialog
          v-model="isShowConfirmDialog"
          persistent
          max-width="640px"
      >
        <v-card>
          <v-card-title>
            <span>{{ translations('shipping_instruction.confirmation_processing') }}</span>
          </v-card-title>
          <v-card-text>
            <div class="h5">{{ translations('shipping_instruction.change_all_displayed_data_to_commit') }}</div>
            <v-divider></v-divider>
            <label><b>{{ translations('sale.remarks') }}</b></label>
            <div><pre class="body-2">{{ remarks }}</pre></div>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-btn
                text
                @click="isShowConfirmDialog = false"
            >
              {{ translations('shipping_instruction.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="confirmAll"
            >
              {{ confirmData && confirmData.id ? translations('common.update') : translations('common.register') }} & {{ translations('shipping_instruction.send_email') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>

    <ShippingDownloadFilesModal
      :selectWarehouseId="selectWarehouseId"
      :warehouses="warehouses"
      :shippingDate="shippingDate"
      :isLogged="isLogged"
    />
    <DocumentFormModal
      :is-update="isUpdateDocument"
      :is-open="isOpenDocumentModal"
      :document="document"
      @close="closeDocumentModal"
    />
    <DeleteDocumentFormModal
      :is-open="isOpenDeleteDocumentModal"
      :is-delete="isDeleteDocument"
      :document="document"
      @close="closeDocumentModal"
    />
    <ShippingFilesModal
      :is-open-file="isOpenFileModal"
      :masterFile="masterFile"
      @close="closeDocumentModal"
    />
    <PrintShippingInstructionModal
      :is-open-print="isOpenPrintModal"
      :shippingSelected="shippingsSelected"
      @close="closeDocumentModal"
    />
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ShippingDownloadFilesModal from '@/components/ShippingDownloadFilesModal'
import DocumentFormModal from '@/components/DocumentFormModal'
import DeleteDocumentFormModal from '@/components/DeleteDocumentFormModal'
import ShippingFilesModal from '@/components/ShippingFilesModal'
import PrintShippingInstructionModal from '@/components/PrintShippingInstructionModal'
import { saveAs } from 'file-saver'
import _ from 'lodash'
import DivisionTypeText from '@/components/orders/DivisionTypeText'
import { mapState } from 'vuex'

const Papa = require('papaparse')
const encoding = require('encoding-japanese')

const TEMP_SHIPPING_STATUS = {
  all: -1,
  send_temp: 1,
  not_send_temp: 0
}

export default {
  name: 'ShippingInstructions',
  components: {
    VueElementLoading,
    ShippingDownloadFilesModal,
    DocumentFormModal,
    DivisionTypeText,
    DeleteDocumentFormModal,
    ShippingFilesModal,
    PrintShippingInstructionModal
  },
  data () {
    return {
      isLoading: false,
      isLoadingModal: false,
      isUpdateDocument: false,
      isOpenDocumentModal: false,
      isOpenDeleteDocumentModal: false,
      isDeleteDocument: false,
      isOpenFileModal: false,
      isOpenPrintModal: false,
      warehouses: [],
      showHiddenDeletedShippingDetail: false,
      searchWord: '',
      shippingDate: '',
      // tempDateField: '',
      selectWarehouseId: 0,
      shippings: [],
      shippingsTemp: [],
      shippingsMain: [],
      shippingsNotDelete: [],
      shippingsDeleteAndConfirm: [],
      shippingsPrintNotDelete: [],
      shippingsPrintNotDeleteTemp: [],
      shippingsPrintNotDeleteMain: [],
      shippingsSelected: [],
      shippingsSelectedTemp: [],
      shippingsSelectedMain: [],
      shippingsSelectedDelete: [],
      documents: [],
      document: {},
      selectDocumentId: 0,
      isSendTemp: 0,
      isShowAllShipping: false,
      isChecked: false,
      isEmpty: false,
      isEmptyMsg: '',
      confirmData: null,
      confirmDetails: [],
      isShowConfirmDialog: false,
      isShowRemarksDialog: false,
      remarks: '',
      startPositionRemark: 0,
      endPositionRemark: 0,
      timeOutId: null,
      timeReload: 1800000,
      options: {
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      // YAMA@UNIQ ADD 2021/12
      masterFile: '',
      apiUrl: process.env.VUE_APP_SHINTARO_API_URL
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    isLogged: function () {
      return this.$store.getters['User/isLogged']
    },
    isWarehouseUser: function () {
      return this.$store.getters['WarehouseUser/isLogged']
    },
    selectWarehouseName () {
      const warehouse = this.warehouses.find(w => Number(w.id) === Number(this.selectWarehouseId))
      return warehouse ? warehouse.name : this.translations('shipping_instruction.warehouse_selection')
    },
    selectDocumentTitle () {
      const title = this.documents.find(title => Number(title.id) === Number(this.selectDocumentId))
      return title ? title.title : this.translations('shipping_instruction.fixed_phrase_selection')
    },
    isEnableConfirm () {
      let shippingIsNotDelete = this.shippings.filter(function callback (element, index, array) {
        return element.is_delete !== '1'
      })
      let confirmIsNotDelete = this.confirmDetails.filter(function callback (element, index, array) {
        return element.is_delete !== '1'
      })
      return confirmIsNotDelete.length && (confirmIsNotDelete.length === shippingIsNotDelete.length)
    },
    isAllConfirm () {
      let confirmIsNotDelete = this.confirmDetails.filter(function callback (element, index, array) {
        return element.is_delete !== '1'
      })
      console.log(confirmIsNotDelete.length)
      return confirmIsNotDelete.length && this.confirmDetails.filter(d => Boolean(Number(d.is_confirm))).length === confirmIsNotDelete.length
    },
    detailColorClass () {
      return (id) => {
        const detail = this.confirmDetails.find(d => Number(d.sale_id) === id)
        if (!detail) {
          return 'text-black bg-secondary'
        } else if (Number(detail.is_confirm)) {
          return 'text-white bg-primary'
        } else {
          return 'text-white bg-warning'
        }
      }
    },
    detailLabel () {
      return (id) => {
        const detail = this.confirmDetails.find(d => Number(d.sale_id) === id)
        if (!detail) {
          return this.translations('shipping_instruction.unregistered')
        } else if (Number(detail.is_confirm)) {
          return this.translations('shipping_instruction.confirmed')
        } else {
          return this.translations('shipping_instruction.hidden')
        }
      }
    },
    detailTooltipText () {
      return (id) => {
        const detail = this.confirmDetails.find(d => Number(d.sale_id) === id)
        if (detail && Number(detail.is_confirm)) {
          return this.translations('shipping_instruction.click_correction_in_progress')
        } else {
          return this.translations('shipping_instruction.click_correction_confirmed')
        }
      }
    },
    selectAll: {
      get: function () {
        let shippingLength = this.showHiddenDeletedShippingDetail ? this.shippings.length : this.shippingsPrintNotDelete.length
        return shippingLength && (shippingLength !== 0 && this.shippingsSelected.length === shippingLength)
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.shippings.forEach(shipping => {
            if (this.showHiddenDeletedShippingDetail) {
              selected.push(shipping)
            } else {
              if (!shipping.is_delete) {
                selected.push(shipping)
              }
            }
          })
        }
        this.shippingsSelected = selected
      }
    },
    selectAllTemp: {
      get: function () {
        let shippingLength = this.showHiddenDeletedShippingDetail ? this.shippingsTemp.length : this.shippingsPrintNotDeleteTemp.length
        return shippingLength && (shippingLength !== 0 && this.shippingsSelectedTemp.length === shippingLength)
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.shippings.forEach(shipping => {
            if (this.showHiddenDeletedShippingDetail) {
              if (Number(shipping.is_send_temp) !== 0) {
                selected.push(shipping)
              }
            } else {
              if (!shipping.is_delete && Number(shipping.is_send_temp) !== 0) {
                selected.push(shipping)
              }
            }
          })
        }
        this.shippingsSelectedTemp = selected
      }
    },
    selectAllMain: {
      get: function () {
        let shippingLength = this.showHiddenDeletedShippingDetail ? this.shippingsMain.length : this.shippingsPrintNotDeleteMain.length
        return shippingLength && (shippingLength !== 0 && this.shippingsSelectedMain.length === shippingLength)
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.shippings.forEach(shipping => {
            if (this.showHiddenDeletedShippingDetail) {
              if (Number(shipping.is_send_temp) !== 1) {
                selected.push(shipping)
              }
            } else {
              if (!shipping.is_delete && Number(shipping.is_send_temp) !== 1) {
                selected.push(shipping)
              }
            }
          })
        }
        this.shippingsSelectedMain = selected
      }
    },
    selectAllDelete: {
      get: function () {
        let shippingLength = this.showHiddenDeletedShippingDetail ? this.shippingsDeleteAndConfirm.length : this.shippingsNotDelete.length
        return shippingLength && (shippingLength !== 0 && this.shippingsSelectedDelete.length === shippingLength)
      },
      set: function (value) {
        let selected = []
        if (value) {
          this.shippings.forEach(shipping => {
            const detail = this.confirmDetails.find(d => Number(d.sale_id) === shipping.id)
            if (this.showHiddenDeletedShippingDetail) {
              if (detail) {
                selected.push(shipping)
              }
            } else {
              if (detail && !shipping.is_delete) {
                selected.push(shipping)
              }
            }
          })
        }
        this.shippingsSelectedDelete = selected
      }
    },
    updatedHeaders () {
      const headers = [
        { text: 'No', sortable: false },
        { text: this.translations('shipping_instruction.instruction_not_allowed'), value: 'status', sortable: false },
        { text: this.translations('shipping_instruction.file_return'), value: 'show_hidden_soft_deleted_shipping_detail', sortable: false },
        { text: this.translations('shipping_instruction.print_selection'), value: 'select_all', sortable: false, hidden: this.isWarehouseUser },
        { text: this.translations('shipping_instruction.provisional_transmission'), value: 'select_all_temp', sortable: false, hidden: !this.isWarehouseUser },
        { text: this.translations('shipping_instruction.main_transmission'), value: 'select_all_main', sortable: false, hidden: !this.isWarehouseUser },
        { text: this.translations('sale.ship_date'), value: 'shipping_schedule_at', sortable: false },
        { text: this.translations('sale.order_number'), value: 'sales_number' },
        { text: this.translations('sale.ship_number'), value: 'ship_number' },
        { text: this.translations('sale.supplier'), value: 'younosuke_company_name' },
        { text: this.translations('sale.jan_code'), value: 'jan_code' },
        { text: this.translations('sale.model'), value: 'model' },
        { text: this.translations('sale.quantity'), value: 'quantity' },
        { text: this.translations('sale.client_order_number'), value: 'client_order_number' },
        { text: this.translations('sale.product_internal_memo'), value: 'internal_memo' },
        { text: this.translations('sale.destination_name'), value: 'destination_name' },
        { text: this.translations('sale.internal_memo'), value: 'note' },
        { text: this.translations('sale.remarks'), value: 'division_type' }
      ]

      let filtered = headers.filter(header => !header.hidden)
      if (this.isWarehouseUser) {
        return filtered.filter(header => header.value !== 'sales_number')
      } else {
        return filtered
      }
    }
  },
  watch: {
    // selectWarehouseId () {
    //   this.init()
    // },
    options: {
      handler () {
        // this.getFilterdList()
      },
      deep: true
    },
    showHiddenDeletedShippingDetail (newVal, oldVal) {
      this.shippingsSelectedDelete = []
      this.shippingsSelected = []
      this.shippingsSelectedTemp = []
      this.shippingsSelectedMain = []
    },
    shippingsSelectedTemp: {
      handler () {
        this.updateShippingsSelected()
      },
      deep: true
    },
    shippingsSelectedMain: {
      handler () {
        this.updateShippingsSelected()
      },
      deep: true
    }
  },
  created: function () {
    if (this.isLogged) {
      this.$store.dispatch('Master/checkMywarehouses').then(() => {
        this.warehouses = this.$store.getters['Master/getMywarehouses']
      })
    }

    if (this.isWarehouseUser) {
      this.initWarehouse()
    }

    const storedFilter = this.$storage.get('ShippingInstructionsFilter')
    if (storedFilter) {
      this.selectWarehouseId = storedFilter.warehouse_id
      this.shippingDate = storedFilter.shipping_date
    } else {
      this.shippingDate = this.$route.query.date || this.$invoiceTools.getCurrentDate()
    }

    // this.shippingDate = '2022-07-05'
    this.initDocument()
  },
  mounted () {
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    // YAMA@UNIQ ADD 2021/12
    selectFile () {
      const masterFile = this.$refs.inputUploadFile.files
      if (this.masterFile.length === 0) {
        this.masterFile = [...this.masterFile, ...masterFile]
        this.$refs.inputUploadFile.value = null
      } else {
        const files = [...masterFile]
        let nameFiles = []
        let fileExist = []
        this.masterFile.forEach(name => {
          nameFiles.push(name['name'])
        })
        files.forEach(file => {
          if (nameFiles.includes(file['name'])) {
            fileExist.push(file['name'])
          }
        })
        if (fileExist.length !== 0) {
          this.$toastr.warning(this.translations('shipping_instruction.notice_file_already_exists'))
          this.$refs.inputUploadFile.value = null
          return
        } else {
          this.masterFile = [...this.masterFile, ...masterFile]
          this.$refs.inputUploadFile.value = null
        }
      }

      this.$refs.inputUploadFile.value = null
    },
    async uploadFile () {
      const { selectWarehouseId, shippingDate } = this
      this.isLoading = true
      if (this.masterFile.length === 0) {
        this.$toastr.error(this.translations('shipping_instruction.message_choose_file'))
        this.isLoading = false
        return
      }

      if (selectWarehouseId === 0) {
        this.$toastr.error(this.translations('shipping_instruction.message_error_choice_warehouse'))
        this.isLoading = false
        return
      }
      const formData = new FormData()
      for (let i = 0; i < this.masterFile.length; i++) {
        formData.append('file[]', this.masterFile[i])
        formData.append('warehouse_id', selectWarehouseId)
        formData.append('upload_at', shippingDate)
      }
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      await this.$http.post(this.apiUrl + '/edi_master_file/', formData, config).then(response => {
        const { data: { status, message } } = response
        if (status === 'OK') {
          this.$toastr.success(this.translations('shipping_instruction.message_upload_complete'))
        } else {
          this.$toastr.error(message)
        }
      }).catch(e => {
        this.$toastr.error(this.translations('shipping_instruction.message_upload_complete') + '!!!')
      }).finally(() => {
        this.$refs.inputUploadFile.value = null
        this.masterFile = ''
        this.isLoading = false
      })
    },
    renderText (header) {
      let confirmIsNotDelete = this.shippings.filter(function callback (element, index, array) {
        return element.is_delete === '1'
      })

      if (confirmIsNotDelete.length > 0) {
        return header.text
      }
      return ''
    },
    isLoggedSale (isDelete) {
      if (this.showHiddenDeletedShippingDetail === false) {
        if (isDelete === '1') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    calcTotal () {
      if (this.showHiddenDeletedShippingDetail === false) {
        let shippingIsNotDelete = this.shippings.filter(function callback (element, index, array) {
          return element.is_delete !== '1'
        })
        return shippingIsNotDelete.length
      } else {
        return this.shippings.length
      }
    },
    calcTotalTag () {
      let ShippingData = []
      let returnTotalNumberOrder = 0
      if (this.showHiddenDeletedShippingDetail === false) {
        let shippingIsNotDelete = this.shippings.filter(function callback (element, index, array) {
          return element.is_delete !== '1'
        })
        ShippingData = shippingIsNotDelete
      } else {
        ShippingData = this.shippings
      }
      ShippingData.forEach(element => {
        let eachDetailCount = _.remove(_.uniq(_.map(element.details, 'client_order_number')), (order) => (!['', null].includes(order)))
        returnTotalNumberOrder += eachDetailCount.length
      })
      return returnTotalNumberOrder
    },

    openDownloadFilesModal () {
      window.$('#ShippingDownloadFilesModal').modal('show')
    },

    openSampleDocumentModal (isOpen, isUpdate) {
      const selectDocumentId = this.documents.find(document => Number(document.id) === Number(this.selectDocumentId))
      if ((isUpdate && !this.selectDocumentId) || (isUpdate && !selectDocumentId)) {
        this.$toastr.error(this.translations('shipping_instruction.notice_select_template'), this.translations('common.error'))
        return
      }
      this.document = isUpdate ? this.documents.find(document => Number(document.id) === Number(this.selectDocumentId)) : {}
      this.isUpdateDocument = isUpdate
      this.isOpenDocumentModal = isOpen
    },
    openSampleDeleteDocumentModal (isOpen, isDelete) {
      const selectDocumentId = this.documents.find(document => Number(document.id) === Number(this.selectDocumentId))
      if ((isDelete && !this.selectDocumentId) || (isDelete && !selectDocumentId)) {
        this.$toastr.error(this.translations('shipping_instruction.notice_select_template'), this.translations('common.error'))
        return
      }
      this.document = isDelete ? this.documents.find(title => Number(title.id) === Number(this.selectDocumentId)) : {}
      this.isDeleteDocument = isDelete
      this.isOpenDeleteDocumentModal = isOpen
    },

    closeDocumentModal (isClose, isRefreshDocument) {
      this.isOpenDocumentModal = isClose
      this.isOpenDeleteDocumentModal = isClose
      this.isOpenFileModal = isClose
      this.isOpenPrintModal = isClose
      this.document = {}
      if (isRefreshDocument) this.initDocument()
    },
    // YAMA@UNIQ ADD 2021/12

    openFilesModal (isOpenFile) {
      this.isOpenFileModal = isOpenFile
    },

    openPrintModal (isOpenPrint) {
      this.isOpenPrintModal = isOpenPrint
    },

    // triggerDateFilter () {
    //   if (this.shippingDate !== this.tempDateField) {
    //     this.init()
    //   }
    // },
    // changeSearch () {
    //   this.init()
    // },
    init () {
      this.isLoading = true
      this.options.sortBy = []
      this.options.sortDesc = []
      this.shippingsSelected = []
      this.shippingsSelectedTemp = []
      this.shippingsSelectedMain = []

      this.$storage.set('ShippingInstructionsFilter', { warehouse_id: this.selectWarehouseId, shipping_date: this.shippingDate })

      return this.$http.get(this.$api_url.shipping_instructions + '/data/' + this.selectWarehouseId + '/' + this.shippingDate).then(response => {
        const result = response.data
        if (result.status && result.data) {
          this.confirmData = result.data
          this.remarks = result.data.remarks
          this.confirmDetails = result.details
        } else {
          this.confirmData = null
          this.remarks = ''
          this.confirmDetails = []
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
        this.clickDefaultDocument()
        return this.getFilterdList()
      })
    },
    getFilterdList () {
      if (this.isLoading) {
        return
      }

      if (!this.selectWarehouseId) {
        this.shippings = []
        return
      }

      this.isLoading = true

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      if (this.isShowAllShipping) this.isSendTemp = TEMP_SHIPPING_STATUS.all

      let params = {
        warehouse_id: this.selectWarehouseId,
        schedule_start_at: this.shippingDate,
        schedule_end_at: this.shippingDate,
        offset: 0,
        limit: -1,
        orderbys: orderbys,
        is_descs: isDescs,
        show_closed: false,
        search: this.searchWord,
        is_shipping_instruction: 1,
        is_send_temp: this.isSendTemp,
        all_in_shipping: Number(this.isShowAllShipping),
        from_shipping: true
      }

      this.$http.post(this.$api_url.sales_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.shippings = result.list
          this.shippingsNotDelete = []
          this.shippingsDeleteAndConfirm = []
          this.shippingsPrintNotDelete = []
          this.shippings.forEach(shipping => {
            const detail = this.confirmDetails.find(d => Number(d.sale_id) === shipping.id)
            if (detail && !shipping.is_delete) {
              this.shippingsNotDelete.push(shipping)
            }
            if (detail) {
              this.shippingsDeleteAndConfirm.push(shipping)
            }
          })
          this.shippings.forEach(shipping => {
            if (!shipping.is_delete) {
              this.shippingsPrintNotDelete.push(shipping)
            }
            if (!shipping.is_delete && Number(shipping.is_send_temp) !== 0) {
              this.shippingsPrintNotDeleteTemp.push(shipping)
            }
            if (!shipping.is_delete && Number(shipping.is_send_temp) !== 1) {
              this.shippingsPrintNotDeleteMain.push(shipping)
            }
            if (Number(shipping.is_send_temp) !== 0) {
              this.shippingsTemp.push(shipping)
            }
            if (Number(shipping.is_send_temp) !== 1) {
              this.shippingsMain.push(shipping)
            }
          })
          this.options.itemsPerPage = result.list.length
          this.totalCount = Number(result.total_count)
        } else {
          this.shippings = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
        this.isSendTemp = TEMP_SHIPPING_STATUS.not_send_temp
      })
    },
    confirmAll () {
      this.isLoading = true

      let url = this.$api_url.shipping_instructions
      if (this.confirmData) {
        url += '/' + this.confirmData.id
      }

      const params = {
        warehouse_id: this.selectWarehouseId,
        shipping_at: this.shippingDate,
        remarks: this.remarks,
        details: this.createdetails(),
        is_send_mail: true
      }
      this.$http.post(url, params).then(response => {
        const result = response.data
        if (result.status) {
          this.$toastr.success(this.translations('shipping_instruction.notice_process_completed'), this.translations('common.success'))
          this.init()
        } else {
          this.isLoading = false
        }
      }).catch(e => {
        this.isLoading = false
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isShowConfirmDialog = false
      })
    },
    saveRemarks () {
      this.isLoading = true

      let url = this.$api_url.shipping_instructions
      if (this.confirmData) {
        url += '/' + this.confirmData.id
      }

      const params = {
        warehouse_id: this.selectWarehouseId,
        shipping_at: this.shippingDate,
        remarks: this.remarks
      }

      this.$http.post(url, params).then(response => {
        const result = response.data
        if (result.status) {
          this.$toastr.success(this.translations('shipping_instruction.notice_remarks_saved'), this.translations('common.success'))
          this.init()
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isShowRemarksDialog = false
        this.isLoading = false
        clearTimeout(this.timeOutId)
      })
    },
    detailAction (saleId) {
      const detail = this.confirmDetails.find(d => Number(d.sale_id) === saleId)
      if (detail && Number(detail.is_confirm)) {
        this.changeConfirm_(detail, saleId, Number(false), this.shippingsSelectedDelete.some(shipping => shipping.id === saleId))
      } else {
        this.changeConfirm_(detail, saleId, Number(true), this.shippingsSelectedDelete.some(shipping => shipping.id === saleId))
      }
    },
    changeConfirm_ (detail, saleId, isConfirm, isDelete) {
      this.isLoading = true
      this.shippingsSelectedDelete = this.shippingsSelectedDelete.filter(
        e => e.id !== parseInt(detail.sale_id)
      )

      let url = this.$api_url.shipping_instructions + '/' + this.confirmData.id + '/details'
      if (detail) {
        url += '/' + detail.id
      }

      let params = {
        sale_id: saleId,
        is_confirm: isConfirm,
        isDelete: isConfirm === 1 ? false : isDelete
      }

      this.$http.post(url, params).then(response => {
        const result = response.data
        if (result.status) {
          this.shippingsSelectedDelete = []
          this.$toastr.success(this.translations('shipping_instruction.notice_status_changed'), this.translations('common.success'))
          return this.init()
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
        this.isLoading = false
      }).finally(() => {
        this.isShowRemarksDialog = false
        this.showHiddenDeletedShippingDetail = false
      })
    },
    changeMultipleConfirm (hidden) {
      this.isLoading = true
      let url = this.$api_url.shipping_instructions + '/' + this.confirmData.id + '/change_multiple_confirm'

      let params = {
        details: this.shippingsSelectedDelete,
        hidden: hidden
      }

      this.$http.post(url, params).then(response => {
        const result = response.data
        if (result.status) {
          this.shippingsSelectedDelete = []
          this.$toastr.success(this.translations('shipping_instruction.notice_status_changed'), this.translations('common.success'))
          return this.init()
        }
        this.isLoading = false
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
        this.isLoading = false
      }).finally(() => {
        this.isShowRemarksDialog = false
        this.showHiddenDeletedShippingDetail = false
      })
    },
    createdetails () {
      let returnArray = []
      for (let index = 0; index < this.shippings.length; index++) {
        const detail = this.confirmDetails.find(d => Number(d.sale_id) === Number(this.shippings[index].id))
        if (detail) {
          if (detail.is_delete !== '1') {
            returnArray.push({
              id: detail ? detail.id : '',
              sale_id: Number(this.shippings[index].id),
              is_confirm: Number(true)
            })
          }
        } else {
          returnArray.push({
            id: detail ? detail.id : '',
            sale_id: Number(this.shippings[index].id),
            is_confirm: Number(true)
          })
        }
      }
      return returnArray
    },
    initWarehouse () {
      this.$http.post(this.$api_url.warehouse_user_detail, { user_id: this.$store.getters['WarehouseUser/id'] }).then(response => {
        const result = response.data
        if (result.status) {
          this.warehouses = result.detail.warehouses
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
      })
    },
    async initDocument () {
      this.isLoadingModal = true
      try {
        const { data: { status, list } } = await this.$http.get(this.$api_url.template_shipping_instruction)
        if (status) {
          this.documents = list
        }
      } catch (error) {}
      this.isLoadingModal = false
    },
    clickDocument (item) {
      this.selectDocumentId = item.id
      if (this.startPositionRemark === this.endPositionRemark) {
        const splitRemark = this.remarks.split('')
        splitRemark.splice(this.startPositionRemark, 0, item.description)
        this.remarks = splitRemark.join('')
      } else {
        const splitRemark = this.remarks.split('')
        const rangeSplit = Math.abs(this.endPositionRemark - this.startPositionRemark)
        splitRemark.splice(this.startPositionRemark, rangeSplit, item.description)
        this.remarks = splitRemark.join('')
      }

      // Reset postion cursor
      this.startPositionRemark = 0
      this.endPositionRemark = 0
    },
    clickDefaultDocument () {
      this.selectDocumentId = 0
    },
    exportCsv () {
      this.isLoading = true

      return this.$http.get(this.$api_url.shipping_instructions + '/csv/' + this.confirmData.id).then(response => {
        const result = response.data
        if (result.status) {
          this.saveCsv_(result.list)
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = this.translations('shipping_instruction.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
      })
    },
    saveCsv_ (list) {
      const data = []

      list.forEach(item => {
        data.push([
          item.sale_sales_number,
          item.sale_shipping_at,
          item.younosuke_company_customercode,
          item.younosuke_company_name,
          item.younosuke_destination_hanbaiocode,
          item.sale_destination_name,
          item.sale_shipping_schedule_at,
          item.sale_detail_client_order_number,
          item.sale_detail_jan_code,
          item.sale_detail_model,
          item.sale_detail_quantity,
          item.sale_memo,
          item.product_condition,
          item.internal_memo,
          item.note
        ])
      })

      let csv = ''
      if (this.isWarehouseUser) {
        csv = Papa.unparse({
          fields: [
            '売上伝票.売上伝票番号',
            '売上伝票.売上伝票日付',
            '売上伝票.得意先コード',
            '売上伝票.得意先名',
            '売上伝票.発送先コード',
            '売上伝票.発送先名',
            '売上伝票.発送予定日',
            '売上伝票.摘要',
            '売上伝票.商品コード',
            '売上伝票.商品名',
            '売上伝票.数量',
            '売上伝票.備考',
            '売上伝票.ステータス',
            '売上伝票.商品内部メモ',
            '売上伝票.内部メモ'
          ],
          data: data
        })
      } else {
        csv = Papa.unparse({
          fields: [
            '売上伝票.売上伝票番号',
            '売上伝票.売上伝票日付',
            '売上伝票.得意先コード',
            '売上伝票.得意先名',
            '売上伝票.発送先コード',
            '売上伝票.発送先名',
            '売上伝票.発送予定日',
            '売上伝票.摘要',
            '売上伝票.商品コード',
            '売上伝票.商品名',
            '売上伝票.数量',
            '売上伝票.備考'
          ],
          data: data
        })
      }

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })

      const d = new Date()
      const filename = this.translations('shipping_instruction.shipping_instruction_export_csv') + d.getFullYear() +
          ('0' + (d.getMonth() + 1)).slice(-2) +
          ('0' + d.getDate()).slice(-2) + '_' +
          ('0' + d.getHours()).slice(-2) +
          ('0' + d.getMinutes()).slice(-2) +
          ('0' + d.getSeconds()).slice(-2) + '.csv'

      saveAs(content, filename)

      this.isLoading = false
    },
    showTempShipping () {
      this.isShowAllShipping = false
      this.isSendTemp = TEMP_SHIPPING_STATUS.send_temp
      this.init()
    },
    // changeSelectAll () {
    //   this.init()
    // },
    isShippingTemp (shipping) {
      return Boolean(Number(shipping.is_send_temp)) && this.isChecked
    },
    blurRemark (e) {
      const { target: { selectionStart, selectionEnd } } = e
      this.startPositionRemark = selectionStart
      this.endPositionRemark = selectionEnd
    },
    ShowRemarksDialog () {
      let url = this.$api_url.shipping_instructions + `/check_remark?warehouse_id=${this.selectWarehouseId}&&shipping_at=${this.shippingDate}`
      this.isLoading = true
      this.$http.get(url).then(response => {
        const result = response.data
        if (result.open === true) {
          this.isShowRemarksDialog = true
          this.init()
          this.timeOutId = setTimeout(() => {
            window.location.reload()
          }, this.timeReload)
        } else {
          let userOpen = response.data.userOpen
          this.isEmptyMsg = this.translations('shipping_instruction.notice_feature_not_available') + userOpen +
            this.translations('shipping_instruction.notice_in_use') + this.translations('shipping_instruction.notice_accessing_again')
          this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
        }
      }).catch(e => {
        this.isEmpty = true
        this.isEmptyMsg = 'error 500'
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
      })
    },
    closeRemarkDialog () {
      let url = this.$api_url.shipping_instructions + `/cancel_remark?warehouse_id=${this.selectWarehouseId}&&shipping_at=${this.shippingDate}`
      this.$http.get(url).then(response => {
        const result = response.data
        if (result.status) {
          this.isShowRemarksDialog = false
          this.init()
        }
      }).finally(() => {
        this.isLoading = false
        clearTimeout(this.timeOutId)
      })
    },
    sliceNote (note) {
      let text = ''
      if (note) {
        let noteLength = note.length
        text = noteLength > 15 ? note.slice(0, 15) + '.....' : note
      }
      return text
    },
    submitSearch () {
      if (this.isShowAllShipping) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
      this.init()
    },
    disableCheckBox (shipping) {
      const detail = this.confirmDetails.find(d => Number(d.sale_id) === shipping.id)

      return !shipping.is_confirm === '1' || !detail
    },
    disableButtonChangeMultipleConfirm () {
      return this.shippingsSelectedDelete.length === 0
    },
    disableInputPrintTemp (shipping) {
      return Number(shipping.is_send_temp) === 0
    },
    disableInputPrintMain (shipping) {
      return Number(shipping.is_send_temp) === 1
    },
    updateShippingsSelected () {
      if (this.shippingsSelectedMain.length === 0 && this.shippingsSelectedTemp.length === 0) {
        this.shippingsSelected = []
        return
      }
      const idMap = new Map()

      this.shippingsSelectedTemp.forEach(item => {
        const clonedItem = { ...item, is_user_warehouse_send_temp: 1 }
        idMap.set(item.id, clonedItem)
      })

      this.shippingsSelectedMain.forEach(item => {
        if (idMap.has(item.id)) {
          const existing = idMap.get(item.id)
          existing.is_user_warehouse_send_temp = 2
          idMap.set(item.id, existing)
        } else {
          const clonedItem = { ...item, is_user_warehouse_send_temp: 0 }
          idMap.set(item.id, clonedItem)
        }
      })

      this.shippingsSelected = Array.from(idMap.values())
    }
  }
}
</script>

<style scoped>
.select-all {
  transform: translate(10px,2px);
}

.menu-document {
  max-height: 200px;
  overflow: auto;
}

.cover_input_red input[type="checkbox"]:checked + label {
    color: #337AB7;
    text-decoration: underline;
}
.cover_input_red input[type="checkbox"]:disabled + label {
    color: #ccc;
}

.cover_input_red label {
  margin-bottom: 0;
}
</style>
